module.exports = __webpack_public_path__ + "img/12.6d76eec4.jpg";